import { useChatboxStateContext, useChatboxDispatchContext } from '../context/ChatboxContext';
import BotService from './ConversationAction';
function ChatboxAction() {
    const { valueOpen } = useChatboxStateContext();
    
    const dispatch = useChatboxDispatchContext();

    const openIfClosed = (isMarginRequired = false) => {
        if(valueOpen == true) {
            return;
        }

        dispatch({ type : 'forceOpen'})
    }
    
    const disableSendMoreMsgToServer = () => dispatch({ type : 'setCanSendDataToServer', payload : { value : false }})
    const enableSendMoreMsgToServer = () => dispatch({ type : 'setCanSendDataToServer', payload : { value : true }})

    return { openIfClosed, valueOpen, disableSendMoreMsgToServer, enableSendMoreMsgToServer };
    
}

export default ChatboxAction;
